<script>
export default {
  name: 'SetClass',
  inheritAttrs: false,
  functional: true,
  props: {
    func: {
      type: Function,
      required: true
    }
  },
  render (createElement, context) {
    const mergeClasses = (c1, c2) => {
      let classes = (c1 || '').split(' ')
      for (const c in c2) {
        if (c2[c]) {
          if (!classes.includes(c)) {
            classes.push(c)
          }
        } else {
          classes = classes.filter(e => e !== c)
        }
      }
      return classes.join(' ')
    }
    return context.children.map(vnode => {
      vnode.data.class = mergeClasses(vnode.data.class, context.props.func(vnode))
      return vnode
    })
  }
}
</script>
